const normalizeHistoryValue = (value) =>
  (value ?? '').toString().trim().toLowerCase();

const getHistoryTimestamp = (record) => {
  const parsed = record?.creation_date ? new Date(record.creation_date).getTime() : NaN;
  return Number.isFinite(parsed) ? parsed : null;
};

export const getLatestCustomerHistory = (history, vehicleValue, customerNameValue) => {
  const normalizedVehicle = normalizeHistoryValue(vehicleValue);
  const normalizedName = normalizeHistoryValue(customerNameValue);

  if (!normalizedVehicle && !normalizedName) return null;

  const matches = (history || []).filter((record) => {
    if (normalizedVehicle) {
      return normalizeHistoryValue(record?.Vehicle_no) === normalizedVehicle;
    }

    return normalizeHistoryValue(record?.Customer_name) === normalizedName;
  });

  if (!matches.length) return null;

  return matches.reduce((latest, current) => {
    const latestTimestamp = getHistoryTimestamp(latest);
    const currentTimestamp = getHistoryTimestamp(current);

    if (latestTimestamp != null && currentTimestamp != null) {
      return currentTimestamp > latestTimestamp ? current : latest;
    }
    if (currentTimestamp != null) return current;
    if (latestTimestamp != null) return latest;

    return Number(current?.cikey || 0) > Number(latest?.cikey || 0) ? current : latest;
  }, matches[0]);
};
